import React from 'react';

const MiniStat: React.FC<{ label: string; value: string | number }> = ({ label, value }) => (
  <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-2 text-center">
    <div className="text-sm font-bold text-gray-900 dark:text-gray-100">{value}</div>
    <div className="text-[10px] text-gray-500 dark:text-gray-400">{label}</div>
  </div>
);

export default MiniStat;
